var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8641,
    cy: 13.2148,
    r: 12.7595,
    stroke: "white",
    strokeWidth: 0.911392
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4489 7.18273L10.8205 10.8118V15.19L14.4489 18.8191H15.1841V7.1842H14.4489V7.18273ZM16.5412 7.57327L16.3631 8.28385C17.3035 8.66342 18.109 9.31518 18.6766 10.1556C19.2441 10.996 19.5478 11.9868 19.5485 13.0009C19.5467 14.0142 19.2425 15.004 18.6749 15.8434C18.1073 16.6829 17.302 17.3338 16.3623 17.7129L16.5398 18.4213C17.6369 18.0006 18.581 17.2577 19.2477 16.2902C19.9144 15.3226 20.2726 14.1759 20.275 13.0009C20.2742 11.8248 19.9169 10.6767 19.2504 9.70772C18.5838 8.73879 17.6392 7.99459 16.5412 7.57327ZM16.875 10.2962L16.4823 10.9231C16.7607 11.1931 16.9822 11.516 17.134 11.8728C17.2857 12.2296 17.3646 12.6132 17.3659 13.0009C17.3654 13.3889 17.2873 13.7729 17.1362 14.1302C16.9851 14.4876 16.764 14.811 16.486 15.0817L16.878 15.71C17.2597 15.3694 17.5653 14.952 17.7747 14.4852C17.9841 14.0183 18.0926 13.5126 18.0932 13.0009C18.0917 12.4898 17.9824 11.9848 17.7725 11.5187C17.5626 11.0527 17.2568 10.6361 16.875 10.2962ZM8.63867 10.8198V15.1835H10.0932V10.8198H8.63867Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioCircle);
export default __webpack_public_path__ + "static/media/audio-circle.505dd654a67b37766c717fa29aab5954.svg";
export { ForwardRef as ReactComponent };